import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	winSubactivityOne: 5,
}

export const Tema4SubtopicFourActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema4], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema4 activity 1");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Fondo fijo." />
					<DialogBarNew
						dialog={
							"Es hora de poner en práctica tus conocimientos y ganar puntos. En la tienda Receso obtuviste de recompensa unas monedas, esas son el fondo fijo de la caja."
						}
						percentage={"40%"}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.characterAnimations.idle)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Cobro de productos"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"Pero antes te explicare un poco en que consiste el fondo fijo."
						}
						percentage={"80%"}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act1_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"El fondo fijo, es la cantidad mínima que debes tener siempre en caja. El monto lo define cada plaza."
						}
						percentage={"100%"}
						callback={() => {
							setUiToShow(steps.winSubactivityOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Ten en cuenta llevar a la práctica lo que has aprendido en tu dia a dia."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							navigation("/home4/tema4/subtema4/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}